import Index from "../views/Index/Index";
import Reward from "../views/Reward/Reward";
import Network from '../views/Network/Network';
import Follow from "../views/Follow/Follow";

const routeLists = [
  {
    path: '/index',
    component: Index
  },
  {
    path: '/reward',
    component: Reward
  },
  {
    path: '/network',
    name: '网络异常',
    component: Network
  },
  {
    path: '/follow',
    component: Follow
  },
];

export default routeLists;
